import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  createPlasticTypeItem,
  getAllPlasticTypeItems,
  getDataForEdit,
  updatePlasticTypeItem,
  deletePlasticTypeItem,
} from "../../store/PlasticType/PlasticTypeApi";
import { getProductItems } from "../../store/AppLevelApi/AppLevelApi";
import { headTitle } from "../../utility/GetTableListName";
import { plasticTypeSliceAction } from "../../store/PlasticType/PlasticTypeSlice";

import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsPlasticType } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialPlasticTypeFormData } from "../../ConstantData/InitialData";
//imporint form data error
import { ErrorPlasticTypeFormData } from "../../ConstantData/ErrorOption";
function PlasticType() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getProductItems("product"));
    // dispatch(getAllPlasticTypeItems());
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const plasticTypeList = useSelector(
    (state) => state.plastictype.plasticTypeList
  );

  const productList = useSelector((state) => state.applevel.productList);
  const InitialFormDataStore = useSelector(
    (state) => state.plastictype.initialData
  );
  const plastictypeEditData = useSelector(
    (state) => state.plastictype.dataEdit
  );
  let plastictypeFormError = useSelector(
    (state) => state.plastictype.errorData
  );
  let isError = useSelector((state) => state.plastictype.isError);
  plastictypeFormError = {
    ...ErrorPlasticTypeFormData,
    ...plastictypeFormError,
  };
  let newFormOptionsUser = JSON.parse(JSON.stringify(FormOptionsPlasticType));
  if (productList.length > 0) {
    //to chage factory option coming from server
    newFormOptionsUser = FormOptionsPlasticType.map((item) => {
      if (item?.labelName === "Product") {
        item.options = productList;
      }
      return item;
    });
  }
  const headTitleLabel = headTitle(FormOptionsPlasticType, [
    "Name",
    "Product",
    "Size",
    "Weight Of Plastic Per Pack",
    "Quantity Per Plastic",
    "Weight Of Plastic Per Piece",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={{ ...InitialPlasticTypeFormData }}
      //function coming from store
      getDataForEdit={getDataForEdit}
      delteFun={deletePlasticTypeItem}
      createFun={createPlasticTypeItem} //create function coming from store
      updateFun={updatePlasticTypeItem} //update function coming from store
      FormOptions={newFormOptionsUser}
      OptionName="Create Plastic Type"
      OptionNameList="Plastic Type"
      generalList={plasticTypeList}
      generalModuleList={productList} //list to add different module
      headTitle={headTitleLabel}
      EditData={plastictypeEditData}
      isError={isError}
      ErrorData={plastictypeFormError}
      InitialFormDataStore={InitialFormDataStore}
      setErrorData={plasticTypeSliceAction.setErrorData}
      isNotDeleteBtn={false}
      isSuccess={isSuccess}
      FormStyle={"!w-[70%]"}
    />
  );
}

export default PlasticType;
